// Session timeout configuration
// const INACTIVITY_TIMEOUT = 60 * 1000;   // 1 minute for testing
// const WARNING_TIME = 10 * 1000;         // 10 seconds warning

// PRODUCTION:
const INACTIVITY_TIMEOUT = 60 * 60 * 1000; // 1 hour
const WARNING_TIME = 5 * 60 * 1000;        // 5 minutes

let inactivityTimer = null;
let warningTimer = null;
let boundResetTimer = null; // ✅ Store the bound function reference

const ACTIVITY_EVENTS = [
  'mousedown',
  'mousemove',
  'keypress',
  'scroll',
  'touchstart',
  'click'
];

export const sessionManager = {
  
  startTracking(onWarning, onTimeout) {
    console.log('🕐 Session tracking started');
    
    // Stop any existing tracking
    this.stopTracking();
    
    // ✅ Create and store the bound function
    boundResetTimer = this.resetTimer.bind(this, onWarning, onTimeout);
    
    // Set warning timer
    warningTimer = setTimeout(() => {
      console.log('⚠️ Session warning - timeout soon');
      if (onWarning) onWarning();
    }, INACTIVITY_TIMEOUT - WARNING_TIME);
    
    // Set timeout timer
    inactivityTimer = setTimeout(() => {
      console.log('⏰ Session expired - logging out');
      if (onTimeout) onTimeout();
    }, INACTIVITY_TIMEOUT);
    
    // ✅ Add listeners with the stored bound function
    ACTIVITY_EVENTS.forEach(event => {
      window.addEventListener(event, boundResetTimer, true);
    });
  },
  
  resetTimer(onWarning, onTimeout) {
    // Clear existing timers
    if (inactivityTimer) clearTimeout(inactivityTimer);
    if (warningTimer) clearTimeout(warningTimer);
    
    // Restart timers
    warningTimer = setTimeout(() => {
      console.log('⚠️ Session warning - timeout soon');
      if (onWarning) onWarning();
    }, INACTIVITY_TIMEOUT - WARNING_TIME);
    
    inactivityTimer = setTimeout(() => {
      console.log('⏰ Session expired - logging out');
      if (onTimeout) onTimeout();
    }, INACTIVITY_TIMEOUT);
  },
  
  stopTracking() {
    console.log('🛑 Stopping session tracking');
    
    // Clear timers
    if (inactivityTimer) {
      clearTimeout(inactivityTimer);
      inactivityTimer = null;
    }
    if (warningTimer) {
      clearTimeout(warningTimer);
      warningTimer = null;
    }
    
    // ✅ Remove listeners using the stored bound function
    if (boundResetTimer) {
      ACTIVITY_EVENTS.forEach(event => {
        window.removeEventListener(event, boundResetTimer, true);
      });
      boundResetTimer = null;
    }
  },
  
  isTokenExpired() {
    const token = localStorage.getItem('authToken');
    if (!token) return true;
    return false;
  }
};